module.exports = __webpack_public_path__ + "static/img/school-icon.e54112ac.png";